import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import { AUS_PROPERTY_KEYS } from 'constants/aus';

import { selectCompanyPropertiesAsObject } from './properties.selectors';

export const selectAusSettingsInitialValues = memoizeOne(companyId =>
  createSelector([selectCompanyPropertiesAsObject(companyId)], properties => ({
    [AUS_PROPERTY_KEYS.FANNIE_USERNAME]: properties[AUS_PROPERTY_KEYS.FANNIE_USERNAME] || '',
    [AUS_PROPERTY_KEYS.FANNIE_PASSWORD]: properties[AUS_PROPERTY_KEYS.FANNIE_PASSWORD] || '',
    [AUS_PROPERTY_KEYS.FANNIE_USE_DO]: properties[AUS_PROPERTY_KEYS.FANNIE_USE_DO] === 'true',
    [AUS_PROPERTY_KEYS.FREDDIE_USERNAME]: properties[AUS_PROPERTY_KEYS.FREDDIE_USERNAME] || '',
    [AUS_PROPERTY_KEYS.FREDDIE_PASSWORD]: properties[AUS_PROPERTY_KEYS.FREDDIE_PASSWORD] || '',
    [AUS_PROPERTY_KEYS.FREDDIE_ROLE_TYPE]: properties[AUS_PROPERTY_KEYS.FREDDIE_ROLE_TYPE] || '',
    [AUS_PROPERTY_KEYS.FREDDIE_ROLE_ID]: properties[AUS_PROPERTY_KEYS.FREDDIE_ROLE_ID] || '',
    [AUS_PROPERTY_KEYS.FREDDIE_ROLE_TYPE_2]:
      properties[AUS_PROPERTY_KEYS.FREDDIE_ROLE_TYPE_2] || '',
    [AUS_PROPERTY_KEYS.FREDDIE_ROLE_ID_2]: properties[AUS_PROPERTY_KEYS.FREDDIE_ROLE_ID_2] || '',
    [AUS_PROPERTY_KEYS.FREDDIE_LCA_USERNAME]:
      properties[AUS_PROPERTY_KEYS.FREDDIE_LCA_USERNAME] || '',
    [AUS_PROPERTY_KEYS.FREDDIE_LCA_PASSWORD]:
      properties[AUS_PROPERTY_KEYS.FREDDIE_LCA_PASSWORD] || '',
    [AUS_PROPERTY_KEYS.FREDDIE_SELLER_NUMBER]:
      properties[AUS_PROPERTY_KEYS.FREDDIE_SELLER_NUMBER] || '',
    [AUS_PROPERTY_KEYS.FREDDIE_CREDIT_VENDOR_ID]:
      properties[AUS_PROPERTY_KEYS.FREDDIE_CREDIT_VENDOR_ID] || '',
    [AUS_PROPERTY_KEYS.FREDDIE_CREDIT_VENDOR_TECHNICAL_AFFILIATE_ID]:
      properties[AUS_PROPERTY_KEYS.FREDDIE_CREDIT_VENDOR_TECHNICAL_AFFILIATE_ID] || '',
  })),
);
